var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path5, _path6, _path7, _path8, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechFairLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 338,
    height: 338,
    viewBox: "0 0 338 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.942 168.407L130.166 130.74V89.0977C130.166 67.2825 147.851 49.5977 169.666 49.5977C191.481 49.5977 209.166 67.2825 209.166 89.0977V130.727L167.942 168.407Z",
    stroke: "#01FF94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.429 169.375L206.023 131.805L247.77 131.805C269.592 131.805 287.273 149.516 287.235 171.339C287.197 193.135 269.498 210.774 247.701 210.736L206.038 210.664L168.429 169.375Z",
    stroke: "#01FF94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.713 168.94L207.166 213.281L207.166 248.275C207.166 270.103 189.436 287.78 167.608 287.715C145.826 287.651 128.22 269.941 128.284 248.158L128.408 206.47L169.713 168.94Z",
    stroke: "#01FF94"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.952 170.083L131.269 204.619L93.094 208.915C71.0845 211.392 51.6796 194.481 51.1247 172.339C50.6021 151.492 67.0785 134.168 87.9256 133.646L131.285 132.559L167.952 170.083Z",
    stroke: "#01FF94"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.666,
    cy: 61.0977,
    r: 6,
    fill: "#01FF94"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.666,
    cy: 58.0977,
    r: 6,
    fill: "#01FF94"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.666,
    cy: 122.098,
    r: 6,
    fill: "#01FF94"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.666,
    cy: 278.098,
    r: 6,
    fill: "#01FF94"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.666,
    cy: 282.098,
    r: 6,
    fill: "#01FF94"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.6661,
    cy: 211.098,
    r: 6,
    fill: "#01FF94"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.6661,
    cy: 128.098,
    r: 6,
    fill: "#01FF94"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 274.666,
    cy: 219.098,
    r: 6,
    fill: "#01FF94"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.412 167.928L169.657 114.597L199.823 85.8898C215.626 70.851 240.629 71.4707 255.667 87.2739C270.706 103.077 270.086 128.079 254.283 143.118L224.127 171.816L168.412 167.928Z",
    stroke: "#40A79A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.047 168.949L221.179 170.283L249.958 200.524C265.002 216.333 264.36 241.35 248.525 256.366C232.71 271.365 207.731 270.702 192.732 254.887L164.063 224.656L168.047 168.949Z",
    stroke: "#40A79A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.247 169.579L162.945 227.277L137.595 251.401C121.782 266.449 96.7545 265.791 81.7538 249.934C66.7843 234.11 67.477 209.147 83.3009 194.178L113.585 165.529L169.247 169.579Z",
    stroke: "#40A79A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M167.205 169.091L116.898 166.326L87.4697 141.633C70.5029 127.396 69.3765 101.681 85.0334 86.0154C99.7751 71.2655 123.683 71.2588 138.433 86.0004L169.11 116.661L167.205 169.091Z",
    stroke: "#40A79A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.666 161.518V177.25M155.966 147.098C148.069 147.098 141.666 153.554 141.666 161.518C141.666 175.939 158.566 189.048 167.666 192.098C176.766 189.048 193.666 175.939 193.666 161.518C193.666 153.554 187.264 147.098 179.366 147.098C174.53 147.098 170.253 149.519 167.666 153.225C166.347 151.331 164.596 149.785 162.559 148.719C160.522 147.652 158.261 147.096 155.966 147.098ZM159.866 169.384H175.466H159.866Z",
    stroke: "#0FA958",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(145.666 144.098)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechFairLogo);
export default __webpack_public_path__ + "static/media/techFairLogo.659225477645b71162e80e0fbb11f347.svg";
export { ForwardRef as ReactComponent };